module.exports = __webpack_public_path__ + "img/activity-queue.2d0041d4.svg";